module.exports = __webpack_public_path__ + "static/media/cpa.18cc6ce9.jpg";